var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 72,
    height: 72,
    rx: 13.0909,
    fill: "#FFD600",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 46.5551C34.3897 46.5551 33.4445 45.6099 33.4445 44.4441V42.1846C33.4445 38.4282 35.4663 34.9252 38.7208 33.0425C40.675 31.9123 41.889 29.8096 41.889 27.5554C41.889 24.0633 39.0478 21.2222 35.5556 21.2222C32.0634 21.2222 29.2223 24.0633 29.2223 27.5554C29.2223 28.7213 28.277 29.6665 27.1111 29.6665C25.9452 29.6665 25 28.7213 25 27.5554C25 21.7352 29.7353 17 35.5556 17C41.376 17 46.1113 21.7352 46.1113 27.5554C46.1113 31.3117 44.0895 34.8147 40.835 36.6974C38.8808 37.8278 37.6668 39.9304 37.6668 42.1846V44.4441C37.6668 45.6099 36.7215 46.5551 35.5556 46.5551Z",
    fill: "#DDBC0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5555 55C36.7214 55 37.6666 54.0548 37.6666 52.8889C37.6666 51.723 36.7214 50.7778 35.5555 50.7778C34.3895 50.7778 33.4443 51.723 33.4443 52.8889C33.4443 54.0548 34.3895 55 35.5555 55Z",
    fill: "#DDBC0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/confirmation-icon.1a4007a79094f6e1b93bf4f861236812.svg";
export { ForwardRef as ReactComponent };